import { AddButton } from "@/shared/form/button";
import { FormInModal } from "@/shared/form/form-in-modal";
import { useTranslations } from "use-intl";
import { SaveDynamicProcessModelForm } from "./save-dynamic-process-model-form";

export function SaveEntityBasedDynamicProcessModelFormInModal() {
  const t = useTranslations("DynamicProcesses");
  return (
    <FormInModal
      modalProps={{
        width: 900,
      }}
      title={t("Entity based")}
      trigger={(open) => (
        <AddButton type="text" onClick={open}>
          {t("Entity based")}
        </AddButton>
      )}
      form={(close) => <SaveDynamicProcessModelForm afterSubmit={close} />}
    />
  );
}
